export default __webpack_public_path__ + "static/media/f2.5de15fb0.svg";